import * as queries from '#Utilities/graphql/queries';
import * as mutations from '#Utilities/graphql/mutations';

export default {
    ...queries,
    ...mutations
};
